// @flow
import subscriptionGetters from './subscriptions/getters'

export default {
  // ...searchGetters,
  ...subscriptionGetters,

  isFbAdminPreview(state: State): boolean {
    return !!(state.user && [2, 3].includes(state.user.role))
  },
}
